/* Spanish catalog mirroring locale-vat-purchases-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'vat.term': 'Periodo de IVA',
  'vat.termHelp': 'Un periodo de IVA es el intervalo por el que declaras el IVA. La mayoría de las empresas presenta la declaración cada dos meses, es decir, 6 periodos al año. Para cada periodo se suman el IVA repercutido y el IVA soportado, y la diferencia se paga al Estado o se devuelve.',
  'vat.termShort': 'periodo',
  'vat.deadline': 'PLAZO',
  'vat.amountHelp': 'IVA a pagar significa que debes dinero al Estado porque el IVA repercutido fue mayor que el IVA soportado. IVA a devolver significa que recuperas dinero porque pagaste más IVA en las compras del que cobraste en las ventas.',
  'vat.openReturn': 'Abrir declaración',
  'vat.sortHelp': 'Los periodos se ordenan por estado: Requiere acción debe presentarse ahora, Próximos son periodos futuros y Anteriores ya están presentados o pagados.',
  'vat.noTerms': 'Aún no hay periodos de IVA',
  'vat.incompleteBasisTitle': 'La base del IVA está incompleta',
  'vat.incompleteBasisText': 'La declaración de IVA no se presenta como completa porque no se ha documentado la cobertura del libro diario. Los cálculos de los documentos siguen disponibles para diagnóstico, no como base contable completa.',
  'vat.needsAction': 'Requiere acción',
  'vat.upcoming': 'Próximos',
  'vat.earlier': 'Anteriores',
  'vat.toPay': 'IVA a pagar',
  'vat.toPayHelp': 'IVA pendiente total en el que el IVA repercutido es mayor que el IVA soportado.',
  'vat.paidIn': 'Pagado',
  'vat.paidInHelp': 'Pagos de IVA que has registrado en periodos de Plumme.',
  'vat.refunded': 'Devuelto',
  'vat.refundedHelp': 'Devoluciones de IVA que has registrado en periodos de Plumme.',
  'vat.perTerm': 'Por periodo',
  'vat.returnStatus': 'Estado de la declaración de IVA',
  'vat.period': 'Periodo',
  'vat.due': 'Plazo',
  'vat.calculated': 'Liquidación calculada',
  'vat.settlement': 'Liquidación',
  'vat.cancelPayment': 'Cancelar pago',
  'vat.date': 'Fecha',
  'vat.amount': 'Importe',
  'vat.reference': 'Referencia',
  'vat.referencePh': 'Ej.: banca en línea, OCR',
  'vat.payments': 'Pagos',
  'vat.paymentsHelp': 'Resumen de los pagos registrados en este periodo de IVA.',
  'vat.noPayments': 'No hay pagos registrados',
  'vat.fromAccount': 'Desde la cuenta',
  'vat.edit': 'Editar',
  'vat.cancel': 'Cancelar',
  'vat.cancelPaymentTitle': '¿Cancelar el pago?',
  'vat.cancelPaymentConfirm': 'Sí, cancelar el pago',
  'vat.backToTerms': 'Volver a los periodos',
  'vat.importedBasisTitle': 'Importado desde otro sistema contable',
  'vat.importedBasisHelp': 'Las cifras se importaron como base. Puedes crear, presentar y, si es necesario, cancelar la declaración de IVA con el flujo habitual.',
  'vat.outputVat': 'IVA repercutido',
  'vat.outputVatHelp': 'IVA que has cobrado en las ventas del periodo.',
  'vat.inputVat': 'IVA soportado',
  'vat.inputVatHelp': 'IVA deducible que has pagado en las compras del periodo.',
  'vat.netVat': 'IVA neto',
  'vat.netHelp': 'IVA repercutido menos IVA soportado. Un importe positivo se paga; uno negativo se devuelve.',
  'vat.checkStatus': 'Comprobar estado',
  'vat.checkStatusHelp': 'Muestra el estado que Plumme tiene guardado para la declaración de IVA. El estado automático de Altinn o Skatteetaten aún no está conectado en esta parte de Plumme.',
  'vat.seePayment': 'Ver pago',
  'vat.seePaymentHelp': 'Consulta los pagos registrados en este periodo de IVA: fecha, cuenta, importe y referencia.',
  'vat.codeOverview': 'Resumen de códigos para la presentación',
  'vat.codeOverviewHelp': 'La declaración de IVA se construye con códigos de IVA estandarizados de Skatteetaten. Cada código agrupa un tipo concreto de venta o compra. La base es el importe sin IVA. En la inversión del sujeto pasivo se muestran tanto el IVA repercutido como el soportado aunque el importe neto sea cero. Toca un código para ver qué incluye.',
  'vat.codeTapHint': 'Toca un código para ver qué incluye.',
  'vat.code': 'Código',
  'vat.description': 'Descripción',
  'vat.basis': 'Base',
  'vat.rate': 'Tipo',
  'vat.vat': 'IVA',
  'vat.calculatedFrom': 'Calculado a partir de lo que has registrado en la aplicación',
  'vat.delete': 'Eliminar',
  'vat.annulCustoms': 'Anular',
  'vat.annulled': 'Anulada',
  'vat.showAnnulledCustoms': 'Mostrar anuladas',
  'vat.showActiveCustoms': 'Mostrar activas',
  'vat.customsAnnulled': 'Declaración de aduanas anulada',
  'vat.customsAnnulFailed': 'No se pudo anular la declaración de aduanas.',
  'vat.registerCustoms': 'Registrar declaración de aduanas',
  'vat.customsHelp': 'Introduce una declaración de aduanas de mercancías que hayas importado. Plumme calcula el IVA de importación a partir del valor estadístico y lo coloca en el código correcto de la declaración.',
  'vat.flowHelp': 'Revisa las cifras de los justificantes contabilizados. Plumme no puede enviar la declaración de IVA: la presentas en el servicio de Skatteetaten y después marcas aquí el periodo como presentado fuera de Plumme. Luego puedes registrar el pago. El estado de presentado se puede quitar si se marcó por error.',
  'vat.filing.statusFiled': 'Presentada fuera de Plumme',
  'vat.filing.statusFiledPaid': 'Presentada fuera de Plumme y pagada',
  'vat.filing.statusNotFiled': 'No marcada como presentada',
  'vat.filing.reviewFigures': 'Revisar las cifras',
  'vat.filing.reviewedToast': 'Cifras revisadas. Presenta la declaración de IVA en Skatteetaten.',
  'vat.filing.markOutside': 'Marcar como presentada fuera de Plumme',
  'vat.filing.clearStatus': 'Quitar estado de presentada',
  'vat.filing.dialogTitle': 'Presentar la declaración de IVA en Skatteetaten',
  'vat.filing.cannotSend': 'Plumme no puede enviar ni firmar la declaración de IVA. La presentas tú mismo en Skatteetaten y después marcas aquí el periodo como presentado.',
  'vat.filing.step1': 'Abre la declaración de IVA en el servicio de Skatteetaten e introduce las cifras de este periodo desde Plumme.',
  'vat.filing.step2': 'Envíala y fírmala allí, y conserva el comprobante.',
  'vat.filing.step3': 'Marca aquí el periodo como presentado fuera de Plumme. Después puedes registrar el pago, y el periodo cuenta como presentado en el cierre del ejercicio.',
  'vat.filing.termNotEnded': 'El periodo aún no ha terminado. La declaración de IVA solo se puede presentar cuando termina el periodo.',
  'vat.filing.filedDate': 'Fecha de presentación',
  'vat.filing.reference': 'Referencia (opcional)',
  'vat.filing.referencePh': 'Por ejemplo, la referencia del comprobante de Skatteetaten',
  'vat.filing.comment': 'Comentario (opcional)',
  'vat.filing.lockNote': 'Una vez marcado el periodo como presentado, los justificantes que contiene quedan bloqueados. Los cambios deberán hacerse entonces como una corrección.',
  'vat.filing.clearText': 'El periodo aparecerá entonces como no presentado en Plumme y sus justificantes se desbloquearán de nuevo. El cambio queda registrado con quién y cuándo. El estado en Skatteetaten no cambia.',
  'vat.filing.clearReason': 'Motivo (opcional)',
  'vat.filing.markedToast': 'El periodo está marcado como presentado fuera de Plumme',
  'vat.filing.clearedToast': 'Estado de presentada eliminado',
  'vat.filing.failed': 'No se pudo actualizar el estado del IVA.',
  'vat.filing.payAfterFiled': 'Disponible cuando la declaración de IVA se haya presentado en Skatteetaten y esté marcada aquí como presentada.',
  'vat.filing.markedOn': 'Marcada en Plumme',
  'vat.filing.referenceLabel': 'Referencia',
  'vat.filing.commentLabel': 'Comentario',
  'vat.filing.statusNote': 'Plumme no obtiene el estado de Skatteetaten. El estado que se muestra aquí es el que se ha marcado en Plumme.',
  'vat.addComment': 'Añadir un comentario',
  'vat.customs': 'Declaración de aduanas',
  'vat.correctCustoms': 'Corregir declaración de aduanas',
  'vat.saveCustoms': 'Guardar declaración de aduanas',
  'vat.fetchFromAltinn': 'Obtener de Altinn',
  'vat.fetchFromAltinnHelp': 'Rellena automáticamente la referencia y la base aduanera a partir de las declaraciones presentadas.',
  'vat.declarationRef': 'Referencia de la declaración',
  'vat.declarationRefPh': 'Referencia de aduanas',
  'vat.statisticalValue': 'Valor estadístico',
  'vat.vatCode': 'Código de IVA',
  'vat.attachments': 'Adjuntos / rastro de importación',
  'vat.uploadAttachment': 'Subir adjunto',
  'vat.attachmentHelp': 'Opcional, pero recomendado para la pista de auditoría y el seguimiento posterior de la importación.',
  'vat.customsBasis': 'Base aduanera',
  'vat.calculatedVat': 'IVA calculado',
  'vat.deductible': 'Deducible',
  'vat.settlementDate': 'Fecha de liquidación',
  'vat.settlementType': 'Tipo de liquidación',
  'vat.useDueDate': 'Fecha de vencimiento',
  'vat.useDueDateHelp': 'Establece la fecha de liquidación en la fecha de vencimiento de la declaración de IVA',
  'vat.addSurcharges': 'Añadir intereses/recargo',
  'vat.surcharges': 'Intereses y recargo',
  'vat.removeSurcharges': 'Quitar',
  'vat.lateInterest': 'Intereses de demora',
  'vat.lateInterestHelp': 'Se contabiliza como gasto financiero en 8150',
  'vat.penaltyFee': 'Recargo o multa coercitiva',
  'vat.penaltyFeeHelp': 'Se contabiliza en 7799 y no es deducible fiscalmente',
  'vat.surchargeTotal': 'Cargado en la cuenta',
  'vat.surchargeNote': 'Los intereses y recargos no son IVA. Se contabilizan como gasto y se cargan en la cuenta, pero no cambian la liquidación de IVA del periodo.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Pagar el IVA a la administración tributaria',
  'vat.payHelp': 'El número de cuenta y el KID los facilita la administración tributaria una vez procesada la declaración. El pago directo desde el banco aún no está conectado, así que por ahora el pago se registra en Plumme.',
  'vat.awaitingAuthority': 'Lo facilita la administración tributaria',
  'vat.pay': 'Pagar',
  'vat.kidHelp': 'KID de la declaración de IVA',
  'vat.authorityAccount': 'Número de cuenta de Skatteetaten',
  'vat.authorityAccountHelp': 'El número de cuenta de Skatteetaten',
  'vat.notRegistered': 'La empresa no está configurada como registrada a efectos de IVA',
  'vat.view': 'Vista',
  'vat.viewHelp': 'Cambia entre «Periodos», una tarjeta por periodo de IVA con estado y plazo, y «Resumen», que suma lo que debes, lo que has pagado y lo que tienes a devolver en todos los periodos.',
  'vat.viewTerms': 'Periodos',
  'vat.viewOverview': 'Resumen',
  'vat.filing.notFiled': 'No presentada',
  'vat.filing.upcomingStatus': 'Próximo',
  'vat.filing.importedArchive': 'Archivo importado',
  'vat.vatReceivable': 'IVA a devolver',
  'vat.vatToPay': 'IVA a pagar',
  'vat.noVat': 'Sin IVA',
  'vat.noneWithWord': 'Sin {{word}}',
  'vat.manualUnsupported': '{{word}} en asientos manuales aún no está activado para {{country}}',
  'vat.manual.input25': '1 - IVA soportado 25 %',
  'vat.manual.input15': '11 - IVA soportado 15 %',
  'vat.manual.input12': '13 - IVA soportado 12 %',
  'vat.manual.output25': '3 - IVA repercutido 25 %',
  'vat.manual.output15': '31 - IVA repercutido 15 %',
  'vat.manual.output12': '33 - IVA repercutido 12 %',
  'vat.manual.reverseGoods25': '81 - Inversión del sujeto pasivo, bienes 25 %',
  'vat.manual.reverseServices25': '86 - Inversión del sujeto pasivo, servicios 25 %',
  'vat.manual.importVatOnly25': '14 - Solo IVA soportado 25 %',
  'vat.manual.importBasis25': '21 - Base de importación 25 %',
  'vat.manual.importBasisZero': '23 - Base de importación sin IVA (SAF-T 20)',
  'vat.receivableShort': 'A devolver',
  'vat.remainingToPay': 'Pendiente de pago',
  'vat.termLabel': 'Periodo {n} de {year}',
  'vat.noTermsHelp': 'Cuando la empresa esté registrada a efectos de IVA, Plumme mostrará aquí los periodos, los plazos y el IVA calculado.',
  'vat.youOwe': 'Debes',
  'vat.youAreOwed': 'Te deben',
  'vat.noVatToSettle': 'No hay IVA que liquidar',
  'vat.refund': 'Devolución',
  'vat.paymentNoun': 'Pago',
  'vat.settlementNoun': 'Liquidación',
  'vat.acctBankDeposit': 'Depósito bancario',
  'vat.acctTaxDeductionAccount': 'Cuenta de retenciones fiscales',
  'vat.acctCash': 'Efectivo',
  'vat.accountFallback': '{code} Cuenta',
  'vat.settlementFullyRegistered': 'Registrada por completo',
  'vat.settlementPartiallyRegistered': 'Registrada parcialmente',
  'vat.settlementNotRegistered': 'No registrada',
  'vat.editRefund': 'Editar devolución',
  'vat.editPayment': 'Editar pago',
  'vat.receivedOn': 'Recibido en',
  'vat.paidFrom': 'Pagado desde',
  'vat.noPaymentsHelp': 'Cuando registres un pago o una devolución del periodo, aparecerá aquí.',
  'vat.addRefund': 'Añadir devolución',
  'vat.addPayment': 'Añadir pago',
  'vat.cancelPaymentConfirmPrefix': '¿Quieres cancelar el registro de {kind} por',
  'vat.cancelPaymentConfirmDate': ' con fecha {date}',
  'vat.cancelPaymentConfirmSuffix': '? El importe se elimina del periodo de IVA y no se puede recuperar.',
  'vat.overpaid': 'Pagado de más',
  'vat.overrefunded': 'Devuelto de más',
  'vat.remainingToReceive': 'Pendiente de recibir',
  'vat.registerSettlement': 'Registrar liquidación',
  'vat.registerPayment': 'Registrar pago',
  'vat.registerRefund': 'Registrar devolución',
  'vat.inYourFavor': 'a tu favor',
  'vat.toTaxAuthority': 'a la administración tributaria',
  'vat.receivedBack': 'Recibido de vuelta',
  'vat.archiveCannotSettle': 'El historial importado no se puede liquidar como un nuevo periodo de Plumme.',
  'vat.noVatToSettleForTerm': 'El periodo no tiene IVA que liquidar.',
  'vat.sourceImported': 'Importado',
  'vat.sourceManual': 'Registrado manualmente',
  'vat.registerVatRefund': 'Registrar devolución de IVA',
  'vat.registerVatPayment': 'Registrar pago de IVA',
  'vat.saveRefund': 'Guardar devolución',
  'vat.savePayment': 'Guardar pago',
  'vat.remainingHint': 'Pendiente {amount}',
  'vat.notRegisteredHelp': 'Cuando la empresa esté configurada como registrada a efectos de IVA en los ajustes, Plumme mostrará aquí los periodos de IVA, el resumen de códigos y la liquidación.',
  'vat.reviewReadyToast': 'La declaración de IVA está lista para revisión',
  'vat.customsAltinnNotConnected': 'La importación desde Altinn de declaraciones de aduanas aún no está conectada.',
  'vat.selectAttachmentToUpload': 'Selecciona un adjunto para subir',
  'vat.customsDefaultDescription': 'Declaración de aduanas',
  'vat.customsDateTermHint': 'La fecha debe estar dentro de {period}.',
  'vat.customs81': '25 % con derecho a deducción',
  'vat.customs82': '25 % sin derecho a deducción',
  'vat.customs83': '15 % con derecho a deducción',
  'vat.customs84': '15 % sin derecho a deducción',
  'vat.customs85': 'Importación al 0 %',
  'vat.customsSaved': 'Declaración de aduanas guardada',
  'vat.customsSaveFailed': 'No se pudo guardar la declaración de aduanas.',
  'vat.customsDeleted': 'Declaración de aduanas eliminada',
  'vat.customsDeleteFailed': 'No se pudo eliminar la declaración de aduanas.',
  'vat.refundSaved': 'Devolución guardada',
  'vat.paymentSaved': 'Pago guardado',
  'vat.paymentSaveFailed': 'No se pudo guardar el pago.',
  'vat.refundCancelled': 'Devolución cancelada',
  'vat.paymentCancelled': 'Pago cancelado',
  'vat.paymentCancelFailed': 'No se pudo cancelar el pago.',
  'vat.supplierSearch': 'Buscar o añadir un proveedor...',
  'vat.supplierClose': 'Cerrar la selección de proveedor',
  'vat.supplierNone': 'No se encontraron proveedores.',
  'vat.supplierNew': 'Nuevo proveedor',
  'vat.supplierName': 'Nombre',
  'vat.supplierOrg': 'N.º de empresa',
  'vat.supplierEmail': 'Correo electrónico',
  'vat.supplierPhone': 'Teléfono',
  'vat.customsPostingExplanation': 'Usa los importes de la declaración de aduanas. El IVA no deducible debe contabilizarse en la cuenta de gasto o de activo adecuada.',
  'vat.nonDeductibleAccount': 'Cuenta para el IVA no deducible',
  'vat.nonDeductibleAccountHelp': 'Introduce la cuenta de gasto o de activo usada para la adquisición. Se requiere una cuenta antes de contabilizar.',
  'voucherList.titleHelp': 'Un justificante es la documentación de un asiento: una factura, un recibo, otra venta, una declaración de aduanas o un asiento libre. Aquí ves los justificantes obtenidos del backend para el ejercicio fiscal seleccionado.',
  'voucherList.backToTrialBalance': 'Volver al balance de comprobación',
  'voucherList.backToIncomeStatement': 'Volver a la cuenta de resultados',
  'voucherList.accountBadge': 'Cuenta {number} · {name}',
  'voucherList.vatCodeBadge': 'Código de IVA {code}',
  'voucherList.viewOptions': 'Opciones de vista',
  'voucherList.noneForVatCode': 'No se encontraron justificantes con el código de IVA {code} en el periodo seleccionado.',
  'voucherList.noneForAccount': 'No hay justificantes contabilizados en {number} {name} en {year}.',
  'voucherList.noneMatchSearch': 'Ningún justificante coincide con la búsqueda.',
  'voucherList.noneInView': 'Ningún justificante coincide con esta vista.',
  'voucherList.ledgerLinesMissing': 'Los justificantes no tienen líneas de asiento del backend.',
  'voucherList.debit': 'Debe',
  'voucherList.credit': 'Haber',
  'voucherList.colVoucher': 'Justificante',
  'voucherList.colNumber': 'N.º de justificante',
  'voucherList.colDate': 'Fecha',
  'voucherList.inlineVat': 'IVA',
  'voucherList.kindInvoice': 'Factura',
  'voucherList.kindSupplier': 'Proveedor',
  'voucherList.kindCreditNote': 'Nota de crédito',
  'voucherList.kindManual': 'Justificante manual',
  'voucherList.kindPurchase': 'Compra',
  'voucherList.kindOtherSale': 'Otra venta',
  'voucherList.kindMileage': 'Registro de kilometraje',
  'voucherList.kindCustoms': 'Declaración de aduanas',
  'voucherList.kindCustomsCorrection': 'Corrección de periodo de declaración de aduanas',
  'voucherList.kindBankPosting': 'Asiento bancario',
  'voucherList.kindPayment': 'Pago',
  'voucherList.kindPayroll': 'Nómina',
  'voucherList.kindPayrollPayment': 'Pago de nómina',
  'voucherList.kindReversal': 'Reversión',
  'voucherList.kindPublicFees': 'Impuestos y tasas públicas',
  'voucherList.kindAssetDisposal': 'Baja de activo',
  'voucherList.kindYearEnd': 'Cierre del ejercicio',
  'voucherList.kindQuote': 'Presupuesto',
  'voucherList.kindOrderConfirmation': 'Confirmación de pedido',
  'voucherList.filterSales': 'Ventas',
  'voucherList.filterSupplierInvoice': 'Factura de proveedor',
  'voucherList.filterFreePosting': 'Asiento libre',
  'voucherList.missingAttachment': 'Falta el adjunto',
  'voucherList.hasAttachment': 'Tiene adjunto',
  'voucherList.unpaid': 'Pendiente de pago',
  'voucherList.showAnnulled': 'Mostrar anulados',
  'voucherList.hidePayments': 'Ocultar pagos',
  'voucherList.includeAnnulled': 'Incluir anulados',
  'vat.amountOnly': 'Solo importe del IVA',
  'voucherList.onlyAnnulled': 'Mostrar solo anulados',
  'voucherList.paid': 'Pagada',
  'voucherList.partiallyPaid': 'Pagada parcialmente',
  'voucherList.annulled': 'Anulado',
  'voucherList.attachmentLost': 'Justificante perdido',
  'voucherList.openInvoiceList': 'Ver en la lista de facturas',
  'voucherList.editSale': 'Editar venta',
  'voucherList.openInBank': 'Abrir en el banco',
  'voucherList.editPosting': 'Editar asiento',
  'voucherList.correctPosting': 'Corregir justificante',
  'voucherList.editMileage': 'Editar registro de kilometraje',
  'voucherList.openInVat': 'Abrir en IVA',
  'voucherList.edit': 'Editar',
  'voucherList.purchaseNotFound': 'No se encontró la compra que se quiere editar. Actualiza la página e inténtalo de nuevo abriendo el justificante.',
  'voucherList.saleNotFound': 'No se encontró la venta que se quiere editar. Actualiza la página e inténtalo de nuevo abriendo el justificante.',
  'inboxStatus.alreadyBooked': '¿Ya contabilizado?',
  'inboxStatus.booked': 'Contabilizado',
  'inboxStatus.inTrash': 'En la papelera',
  'inboxStatus.readyToBook': 'Listo para contabilizar',
  'inboxStatus.needsReview': 'Requiere revisión',
  'inboxStatus.analysisFailed': 'Falló el análisis',
  'inboxStatus.analyzing': 'Analizando',
  'inboxStatus.awaitingAnalysis': 'Esperando análisis',
  'inboxStatus.show': 'Mostrar',
  'inboxStatus.hide': 'Ocultar',
  'inboxStatus.dropReceipts': 'Suelta aquí los recibos',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma lee lo que puede',
  'inboxStatus.dropDocuments': 'Suelta aquí los documentos',
  'inboxStatus.dropDocumentsHint': 'Se añaden a Documentación',
  'inboxStatus.bookWithSuperPlumma': 'Contabilizar con SuperPlumma',
  'inboxStatus.saving': 'Guardando...',
  'purchaseFlow.stepReceipt': 'Recibo',
  'purchaseFlow.stepDetails': 'Detalles',
  'purchaseFlow.stepLines': 'Líneas',
  'purchaseFlow.stepPreview': 'Vista previa',
  'purchaseFlow.typeRegular': 'Compra pagada',
  'purchaseFlow.typeInvoice': 'Factura de proveedor',
  'purchaseFlow.typeDrafts': 'Borradores',
  'purchaseFlow.receivedReading': 'Recibo recibido: SuperPlumma lo está leyendo ahora',
  'purchaseFlow.receivedReadingMany': '{count} recibos recibidos: SuperPlumma los está leyendo ahora',
  'purchaseFlow.prefilled': 'SuperPlumma rellenó lo que pudo leer del recibo. Revísalo antes de contabilizar.',
  'purchaseFlow.amountReview': 'No se pudieron rellenar los importes y el IVA de forma fiable. Revisa el recibo e introduce el importe neto y el tratamiento de IVA correcto de cada línea antes de contabilizar.',
  'purchaseFlow.analysisFailed': 'El recibo se subió, pero falló el análisis.',
  'purchaseFlow.inboxResolveFailed': 'La entrada se guardó, pero el recibo no se quitó de la bandeja de entrada. Márcalo allí como contabilizado.',
  'purchaseFlow.receiptFallbackName': 'Recibo',
});
